import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Box,
} from '@mui/material'
import { useEffect, useRef, useState } from 'react'
import { useOrgan } from '../../../../hooks/useOrgan'
import { organizationPrimaryColors } from '../../../../layouts/PermanentSidebarMUI'
import { useMutation } from '@tanstack/react-query'
import { entities } from '../../../../constants/entities'
import useBaseService from '../../../../hooks/services/useBaseService'
import { useNavigate } from 'react-router-dom'
import useLoader from '../../../../hooks/useLoader'
import { useReport } from '../../../../context/ReportContext'

export const DialogExportIndividualTag = ({ data, open, onClose }) => {
  const [equipmentNumber, setEquipmentNumber] = useState('')
  const inputRef = useRef(null)

  const navigate = useNavigate()
  const { get: baseServiceGet } = useBaseService(navigate)
  const { showLoader, hideLoader } = useLoader()
  const { setExportId, isExporting } = useReport()

  // Limpa o input a cada abertura e mantém o foco para o bip
  useEffect(() => {
    if (open) {
      setEquipmentNumber('')
      setTimeout(() => inputRef.current?.focus(), 0)
    }
  }, [open])

  const exportIndividualTag = useMutation({
    mutationFn: async ({ movementId, number }) => {
      showLoader()
      const response = await baseServiceGet(
        entities.reports.tagVolumeEquipment(movementId),
        { number }
      )
      return response
    },
    onSuccess: (response) => {
      if (response?.status === 202 || response?.status === 200) {
        const generated_id = response.result?.export_id

        if (generated_id) {
          setExportId(generated_id)
          localStorage.setItem('report_exportId', generated_id.toString())
        }
      }
    },
    onError: (error) => {
      console.error('onError ', error)
      hideLoader()
    },
    onSettled: () => {
      hideLoader()
      // Limpa e devolve o foco para o próximo bip
      setEquipmentNumber('')
      setTimeout(() => inputRef.current?.focus(), 0)
    },
  })

  const handleSubmit = () => {
    const number = equipmentNumber.trim()
    if (!number || !data?.id) return
    exportIndividualTag.mutate({ movementId: data.id, number })
  }

  const { selectedOrgan } = useOrgan()
  const primaryColor = selectedOrgan?.name
    ? organizationPrimaryColors[selectedOrgan.name.toUpperCase()] ||
      organizationPrimaryColors.ALUCOM
    : organizationPrimaryColors.ALUCOM

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      disableEnforceFocus>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          backgroundColor: primaryColor,
          color: '#FFFFFF',
        }}>
        <DialogTitle sx={{ fontWeight: 'bold' }}>
          Imprimir Etiqueta Individual
        </DialogTitle>
      </Box>
      <DialogContent>
        <div className="container-fluid p-1">
          <TextField
            inputRef={inputRef}
            autoFocus
            fullWidth
            label="Bipe ou digite o número (patrimônio) do equipamento"
            value={equipmentNumber}
            onChange={(e) => setEquipmentNumber(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault()
                handleSubmit()
              }
            }}
            disabled={isExporting}
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="error">
          Fechar
        </Button>
        <Button
          onClick={handleSubmit}
          color="primary"
          disabled={isExporting || equipmentNumber.trim() === ''}>
          Imprimir
        </Button>
      </DialogActions>
    </Dialog>
  )
}
